export default __webpack_public_path__ + "static/media/partner_logo_07.dcbb7eb5.png";